import type { AuthorizationType } from '@shared/core-types';
import type { Language } from '@luna/i18n';
import type { AppearanceMode } from '@shared/dark-mode-utils';

export enum SecurityAppVariant {
    APP = 'APP',
    DESKTOP = 'DESKTOP',
    DUAL = 'DUAL',
}

export interface WebApiSettings {
    language?: Language;
    tacPhoneNumbers?: string[];
    authorizationType?: AuthorizationType;
    authorizationTypes: string[];
    flags?: string[];

    /// props not described in apiary
    loginMode?: string;
    messagesDeletedOlderThanDays?: number;
    passwordExpiresInDays?: number;
    'at-SoftwareTokenInformation'?: {
        flags?: string[];
        statusDate?: string;
        pendingActivationcodes?: number;
        activationcodes?: {
            app?: number;
            desktop?: number;
            backupApp?: number;
            backupDesktop?: number;
        };
        variant?: SecurityAppVariant;
    };
}

export type Settings = WebApiSettings & { appearanceMode: AppearanceMode };
